import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getReclaimInFlight = unaryRpc({
  name: "getReclaimInFlight" as const,
  input: z.object({}),
  output: z.object({
    awaitingEvidence: z.number().int(),
    submitted: z.number().int(),
    pastDue: z.number().int(),
  }),
});
